import React, { useEffect } from 'react';
import { TopInfoCard } from './TopInfoCard';
import { FaWallet, FaArrowDown, FaArrowUp, FaExchangeAlt } from 'react-icons/fa';
import { getDomainConfig } from '../Utils/dynamicBranding';

export const DashboardTopBar = ({ userData, onCardAction }) => {
  useEffect(() => {
    // Set page title dynamically based on domain
    const config = getDomainConfig();
    document.title = `Dashboard - ${config.title}`;
  }, []);

  // When role = 7 (user), all three balances = userData.balance
  // When role = 6 (IB), totalBalance = userData.balance + mt5balance
  // walletBalance = userData.balance, mt5Balance = userData.mt5balance

  const isIB = userData?.role === 6;
  const isUser = userData?.role === 7;

  const walletBalance = userData?.balance < 0 ? 0 : (userData?.balance ?? 0);
  const mt5Balance = userData?.mt5balance < 0 ? 0 : (userData?.mt5balance ?? 0);

  const totalBalance = isIB
    ? walletBalance + mt5Balance
    : walletBalance; // for user role, totalBalance = walletBalance

  // For user role (7), mt5Balance also shows walletBalance (same)
  const mt5BalanceDisplay = isUser ? walletBalance : mt5Balance;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <TopInfoCard
        icon={<FaWallet className="text-sm" />}
        title="Total Balance"
        value={`$${totalBalance.toLocaleString()}`}
        action="All Funds Activities"
        onActionClick={onCardAction}
        routeToPage="funds-activity"
      />

      <TopInfoCard
        icon={<FaArrowDown className="text-sm" />}
        title="Wallet Balance"
        value={`$${walletBalance.toLocaleString()}`}
        action="Deposit Now"
        onActionClick={onCardAction}
        routeToPage="wallet-deposit-widthdraw"
      />

      <TopInfoCard
        icon={<FaExchangeAlt className="text-sm" />}
        title="MT5 Balance"
        value={`$${mt5BalanceDisplay.toLocaleString()}`}
        action="See Transactions"
      />
    </div>
  );
};